const GENERIC_ERROR =
  "Something went wrong. Please try again and contact support if the issue persists";

const isString = (variable) => {
  return typeof variable === "string";
};

export const mapErrorToMessage = (error) => {
  const response = error.response;
  if (!response || response.status >= 500) {
    return GENERIC_ERROR;
  }

  if (!response.data || !response.data.detail) {
    return GENERIC_ERROR;
  }

  if (!isString(response.data.detail)) {
    return GENERIC_ERROR;
  }

  return response.data.detail;
};
